import React from "react";
import AppUrlListener from "./components/AppUrlListener/AppUrlListener";
import { AnalyticsProvider } from "./context/AnalyticsContext/AnalyticsProvider";
import { DataProvider } from "./context/DataContext/DataProvider";
import { UIProvider } from "./context/UIContext/UIContext";

import { EventDetailsProvider } from "./context/EventDetailsProvider/EventDetailsProvider";
import { MapProvider } from "./context/MapContext/MapContext";
import NetworkStatusListener from "./components/NetworkStatusListener/NetworkStatusListener";
import { AccountDetailsProvider } from "./context/AccountDetailsContext/AccountDetailsProvider";
import { EnvProvider } from "./context/envContext/envContext";
const Providers = ({ children }) => {
  return (
    <>
      <EnvProvider>
        <NetworkStatusListener />
        <AppUrlListener />
        <AnalyticsProvider>
        <DataProvider>
          <UIProvider>
            <MapProvider>
              <EventDetailsProvider>
                <AccountDetailsProvider>{children}</AccountDetailsProvider>
              </EventDetailsProvider>
            </MapProvider>
          </UIProvider>
          </DataProvider>
        </AnalyticsProvider>
      </EnvProvider>
    </>
  );
};

export default Providers;
